export const TableColumns = ['Id', 'Descrizione', 'Progressivo', 'Versione', 'Stato', 'Azioni'];